/* eslint no-eval: 0 */

import moment from 'moment';
import React, { cloneElement, useEffect, useState } from 'react';
//style={{ color: 'purple' }}
import { CreateButton, Datagrid, FunctionField, List, sanitizeListRestProps, ShowButton, TextField, TopToolbar, useListContext, useNotify } from 'react-admin';
import FormDialogPayement from '../dialog/FormDialogPayement.js';
import FiltreFrete from '../filtres/FiltreFrete';
//import ExportAgExp from './ExportAgExp';
import PostPagination from '../paginations/pagination';
import { campType, createAutorisation, json, PhoneDestField, PhoneExpField } from '../references.js';
import rowStyle from '../styles/rowStyle';
import { useMediaQuery } from '@material-ui/core';
import CustomGrid from './CustomGrid'

//const style={marginLeft:15,marginTop:5}





 const  ListOrder=(props)=>{

    const [fullname, setFullname] = useState('');
    const {resource,permissions}=props;
    const [listCamps, setListCamps] = useState([]);
    const notify = useNotify();
    const currentDate = moment().format().slice(0,10);
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));

    useEffect(() => {
        
        setFullname(localStorage.getItem('fullname'));  
        fetch(process.env.REACT_APP_URL+'/camp/getCampagneForFilters?resource='+resource, { method: 'GET',
        headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": "Bearer "+ localStorage.getItem('token')
        }
    }
        ).then(json)
        .then((data) => {
            if(data && data.status>310 && data.error){
                notify(data.error+' : '+data.message,'error');
            } else {
                setListCamps(data);
            }
        }).catch((e) => {
            notify("Erreur lors de la récuperation des campagnes pour le filtre !", 'warning')
        });
       
    }, []);

 return(
        <List {...props}  
                //bulkActionButtons={<PostBulkActionButtons  {...props}/>}
                bulkActionButtons={false}
                actions={<ListActions permissions={permissions} {...props} />}
                filters={<FiltreFrete {...props} listCamps={listCamps}/>} 
                pagination={<PostPagination {...props}/>}
                sort={{ field: 'id', order: 'DESC' }}
                title={campType(resource)+' - '+fullname}
                filterDefaultValues={{"start_date":currentDate,"end_date":currentDate}} 
            >
                 {isSmall ? (
                
                
                <CustomGrid />
            ) : (
            <Datagrid rowStyle={rowStyle} optimized >
                <TextField source="camp_code" label="Campagne" style={{ color: 'purple'  }} sortBy="camp_code"/>
                <TextField source="code" label="Code" sortBy="code"/>
                <TextField source="agent_fullname" label="Agent" sortBy="agent_fullname"/>
                <PhoneExpField source="tel_exp" label="Expéditeur" sortBy="tel_exp"/>
                <PhoneDestField source="tel_dest" label="Destinateur"  sortBy="tel_dest"/>
                <TextField source="total_encaisse" label="Encaissé(€)" sortBy="total_encaisse"/> 
                <TextField source="reste_a_payer" label="Reste a payé(€)" sortBy="reste_a_payer"/>
                <TextField source="total_general" label="Total TTC(€)" sortBy="total_general"/> 
                <TextField source="created_date" label="Date" />
                <ShowButton />    
                <FunctionField render={record =>(record.reste_a_payer) ?  <FormDialogPayement from="list" data={record} /> :  null } />
            </Datagrid>
            )}
        </List>
       ) ;
    };

export default ListOrder;

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        permissions,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button'
            })}
        
        {createAutorisation(permissions,resource) ? <CreateButton basePath={basePath} />:null}
           
        </TopToolbar>
    );
};










/*

const PostBulkActionButtons = props => {
    return <>    
        <p></p>
    </>
    
};

const GuetsiAction = ({
    bulkActions,
    basePath,
    currentSort,
    displayedFilters,
    exporter,
    filters,
    filterValues,
    onUnselectItems,
    resource,
    selectedIds,
    showFilter,
    total,
    data,
    record,
    ...rest
}) => (
    <TopToolbar>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
            record,
            data
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        
        <Button source="credit_status" label="Colis"  color="primary" onClick={()=>this.handleClick()}> <VerticalSplit /> </Button>  
        <CreateButton basePath={basePath} />

    </TopToolbar>
);



*/